/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — on-demand AI assist for the reply box sparkle button.
// POST /api/v1/accounts/:account_id/conversations/:conversation_id/metrica_ai_assist/suggest_reply
// POST /api/v1/accounts/:account_id/conversations/:conversation_id/metrica_ai_assist/summarize
class MetricaAiAssistAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggestReply(conversationId) {
    return axios.post(
      `${this.url}/${conversationId}/metrica_ai_assist/suggest_reply`
    );
  }

  summarize(conversationId) {
    return axios.post(
      `${this.url}/${conversationId}/metrica_ai_assist/summarize`
    );
  }
}

export default new MetricaAiAssistAPI();
